import { Component } from '@angular/core';

@Component({
    selector: 'app-apple',
    templateUrl: './apple.component.svg',
    styleUrls: ['./apple.component.scss'],
})
export class AppleComponent {}
